module.exports = __webpack_public_path__ + "static/wild_bergamot_16x20-c7a73f1516ca637f962d5b0934662455.jpg";